<template>
    <div class="container">
        <figure>
            <img src="/img/clock.svg">
        </figure>
        <div class="heading"> Request Submitted! </div>
        <div class="subheading">
            Your withdrawn funds will be transferred to your registered bank account within 5-7 working days.
        </div>
        <div style="padding-top: 80px; width: 100%; text-align: center;">
            <button class="withdrawButton" @click="routeToDashboard">
                Keep Investing
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WithdrawalRequestSubmitted',
    props: {
        withdrawalOption: {
            type: String
        }
    },
    methods: {
        routeToDashboard () {
            this.$router.push('/dashboard')
        }
    }
}
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 0px;
        height: 80vh !important;
    }

    .heading {
        font-style: normal;
        font-weight: 700;
        font-size: 17px;
        line-height: 24px;
        color: #002FA7;
        padding: 8px 0px 4px 0px;
    }

    .subheading {
        text-align: center;
        font-size: 13px;
        /* padding: 4px 0px; */
        color: #4F4F4F;
    }

    button {
        padding: 11px 24px;
        border-radius: 6px;
        letter-spacing: 0.005em;
        font-size: 14px;
        line-height: 150%;
        font-weight: 600;
        width: 70%;

    }

    .withdrawButton {
        background: #002FA7;
        color: #FFFFFF;
    }
</style>
